import { billStatusTag } from './tag';
import { makeCriteriaProvider } from './enhancers';
import BillStatusFacetDetails from './BillStatusFacetDetails';

export default {
  tag: billStatusTag,
  makeCriteriaProvider,
  DetailsControl: BillStatusFacetDetails
};
